import * as z from 'zod';
import { suretyBondStatusSchema, suretyBondFormTypeSchema } from '../../../enums.mjs';
import '../../../types/actor/actor.mjs';
import '../../../types/address/address.mjs';
import '../../../types/credit-report/company-credit-report.mjs';
import '../../../types/credit-report/individual-credit-report.mjs';
import '../../../types/currency/currency.mjs';
import '../../../types/entityRelation/entity-relation.mjs';
import '../../../types/financial-formula/adjustable-value.mjs';
import '../../../types/financial-formula/adjustable-values-update.mjs';
import '../../../types/financial-formula/adjustment.mjs';
import '../../../types/financial-formula/formula.mjs';
import '@inrev/core';
import '../../../types/is-encrypted.mjs';
import '../../../types/naics-codes/naics-codes.mjs';
import { isoDateSchema, percentSchema, rateSchema, suretyBondPeriodId, suretyQuoteId, userId, agencyId, suretyAccountId, carrierName, suretyBondId, lastName, firstName, timePeriodSchema, suretyBondFormId, companyContactId, individualContactId } from '../../../types/opaque.mjs';
import '../../../types/surety/account/bonding-line.mjs';
import '../../../types/surety/account/surety-account.types.mjs';
import '../../../types/surety/application-extraction/application-extraction-output.mjs';
import '../../../types/surety/application-extraction/application-extraction-webhook.mjs';
import '../../../types/surety/bond/surety-bond.types.mjs';
import '../../../types/surety/bond-form/issued/issued-surety-bond-form.types.mjs';
import '../../../types/surety/bond-form/surety-bond-form.data.mjs';
import '../../../types/surety/bond-request/bond-request-extraction-output.mjs';
import '../../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import '../../../types/surety/contract/contract-extraction-output.mjs';
import '../../../types/surety/contract/contract-extraction-webhook.mjs';
import '../../../types/surety/financial-statement/financial-period/balance-sheet-data.mjs';
import '../../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import '../../../types/surety/financial-statement/financial-period/income-statement-data.mjs';
import '../../../types/surety/financial-statement/financial-period/income-statement-fields.mjs';
import '../../../types/surety/financial-statement/financial-period/income-statement-with-adjustments.mjs';
import '../../../types/surety/financial-statement/financial-period/line-item-group.mjs';
import '../../../types/surety/financial-statement/financial-period/section-keys.mjs';
import '../../../types/surety/financial-statement/financial-period/statement-metadata.mjs';
import '../../../types/surety/financial-statement/financial-period/view-shapes.mjs';
import '../../../types/surety/financial-statement/financial-statement-schemas.mjs';
import '../../../types/surety/indemnity/indemnity-agreement.mjs';
import '../../../types/surety/quote/surety-quote.types.mjs';
import '../../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import '../../../types/surety/work-in-progress-statement/surety-work-in-progress-statement.mjs';
import '../../../types/user/user.types.mjs';
import { currencySchema, attachmentSchema } from '../../../types/utils.mjs';
import * as suretyBondPreview_dto from './preview/surety-bond-preview.dto.mjs';
export { suretyBondPreview_dto as Preview };
import { Obligee } from '../../../types/surety/bond/obligee.types.mjs';

var Get;
(function (Get) {
    (function (Response) {
        let BondPeriod;
        (function (BondPeriod) {
            BondPeriod.schema = z.object({
                id: suretyBondPeriodId,
                amount: currencySchema,
                rate: rateSchema,
                premium: currencySchema,
                agencyCommission: currencySchema,
                agencyCommissionPercentage: percentSchema,
                effectiveDate: isoDateSchema,
                expirationDate: isoDateSchema.optional(),
                quoteId: suretyQuoteId.nullish(),
            });
        })(BondPeriod = Response.BondPeriod || (Response.BondPeriod = {}));
        Response.baseSchema = z.object({
            id: suretyBondId,
            displayTitle: z.string(),
            status: suretyBondStatusSchema,
            closedAt: isoDateSchema.optional(),
            number: z.string(),
            amount: currencySchema,
            rate: rateSchema,
            premium: currencySchema,
            agencyCommission: currencySchema,
            agencyCommissionPercentage: percentSchema,
            effectiveDate: isoDateSchema,
            expirationDate: isoDateSchema.optional(),
            quoteId: suretyQuoteId.nullish(),
            carrierName: carrierName,
            carrierDisplayName: z.string(),
            principalId: z.union([companyContactId, individualContactId]),
            principalName: z.string(),
            accountId: suretyAccountId,
            accountName: z.string(),
            agencyId: agencyId,
            bondForm: z.object({
                id: suretyBondFormId,
                type: suretyBondFormTypeSchema,
                url: z.string(),
            }),
            bondPeriodLength: timePeriodSchema.optional(),
            bondPeriods: z.array(BondPeriod.schema),
            currentBondPeriodId: suretyBondPeriodId,
            description: z.string(),
            name: z.string().nullish(),
            attachments: z.array(attachmentSchema()),
            underwriterUserId: userId,
            underwriter: z.object({
                id: userId,
                firstName: firstName.optional(),
                lastName: lastName.optional(),
            }),
            obligees: z.array(Obligee.schema),
        });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));

export { Get };
